const Routes = {
  About: "About",
  AuthLoading: "AuthLoading",
  CountrySelector: "CountrySelector",
  OnBoarding: "OnBoarding",
  Login: "Login",
  MyProfile: "MyProfile",
  MainTab: "MainTab",
  HomeStack: "HomeStack",
  Chat: "Chat",
  //Onboading
  //Log In & Sign Up
  Recovery: "Recovery",
  RecoveryPassword: "RecoveryPassword",
  ChangePassword: "ChangePassword",
  ChangePasswordSuccessful: "ChangePasswordSuccessful",
  SignUp: "SignUp",
  VerifyPhoneNumber: "VerifyPhoneNumber",
  SignUpSuccessful: "SignUpSuccessful",
  BasicInformation: "BasicInformation",
  WorkProfile: "WorkProfile",
  OtherInformation: "OtherInformation",
  PaymentInformation: "PaymentInformation",
  AddSignature: "AddSignature",
  SentVerifySuccessful: "SentVerifySuccessful",
  CreatingYourFirstPrescription: "CreatingYourFirstPrescription",
  DocumentVisor: "DocumentVisor",
  SendDocuments: "SendDocuments",
  //Home & Schedule
  Home: "Home",
  Notification: "Notification",
  Schedule: "Schedule",
  //Next Consults
  Prescriptions: "Prescriptions",
  PatientPrescriptions: "PatientPrescriptions",
  PatientCertificates: "PatientCertificates",
  Certificates: "Certificates",
  ConsultDetail: "ConsultDetail",
  //Screens
  CallReportProblem: "CallReportProblem",
  SelectAddress: "SelectAddress",
  VideoCallConnected: "VideoCallConnected",
  EndCall: "EndCall",
  PastConsultDetail: "PastConsultDetail",
  WriteAnAnswer: "WriteAnAnswer",
  ShareDoctor: "ShareDoctor",
  //Past Consults
  PastConsultsFilter: "PastConsultsFilter",
  SentDocumentSuccessful: "SentDocumentSuccessful",
  //Private Care - Video Call'
  VideoCall: "VideoCall",
  //Private Care - Live Chat
  PrivateCareLiveChat: "PrivateCareLiveChat",
  ShareMedication: "ShareMedication",
  //Free Consults
  Configuration: "Configuration",
  PrescriptionsRequests: "PrescriptionsRequests",
  FreeConsults: "FreeConsults",
  FreeConsultDetail: "FreeConsultDetail",
  // Search
  Search: "Search",
  SearchMedicines: "SearchMedicines",
  RecentSearch: "RecentSearch",
  SearchResult: "SearchResult",
  DoctorFilter: "DoctorFilter",
  //Search Specials
  SearchSpecialDoctor: "SearchSpecialDoctor",
  SearchDoctorResults: "SearchDoctorResults",
  ConditionsAndSymptoms: "ConditionsAndSymptoms",
  Medications: "Medications",
  MedicationDetail: "MedicationDetail",
  SearchSpecialHospital: "SearchSpecialHospital",
  HospitalDetail: "HospitalDetail",
  //Patients Management
  //
  //Search
  //
  //Search - Specials
  //
  //Private Chat
  ChatStack: "ChatStack",
  PrivateChatStack: "PrivateChatStack",
  PrivateChat: "PrivateChat",
  ChatDetail: "ChatDetail",
  //Health Feed
  HealthFeed: "HealthFeed",
  HealthFeedStack: "HealthFeedStack",
  TipDetail: "TipDetail",
  TopicDetail: "TopicDetail",
  TopicDetailConditions: "TopicDetailConditions",
  //My Work
  MyWorkStack: "MyWorkStack",
  //My Work - Finance Report
  MyWork: "MyWork",
  FinanceReport: "FinanceReport",
  IncomeReport: "IncomeReport",
  WithdrawHistory: "WithdrawHistory",
  //My Work - Topics
  MyWorkTopics: "MyWorkTopics",
  CreateByMe: "CreateByMe",
  FollowingTopics: "FollowingTopics",
  TopicDetails: "TopicDetails",
  TopicCreate: "TopicCreate",
  TopicAddCondition: "TopicAddCondition",
  //My Work - Health Guide & Tips
  HealthGuide: "HealthGuide",
  HealthGuideDetail: "HealthGuideDetail",
  HealthGuideSaved: "HealthGuideSaved",
  HealthGuideSavedDetail: "HealthGuideSavedDetail",
  HealthGuideCreate: "HealthGuideCreate",
  HealthTips: "HealthTips",
  HealthTipsCreate: "HealthTipsCreate",
  //My Work - Library
  MyWorkLibrary: "MyWorkLibrary",
  MyWorkNetwork: "MyWorkNetwork",
  WorkProfileManagement: "WorkProfileManagement",
  SendMessage: "SendMessage",
  OnlineAppointment: "OnlineAppointment",
  SetWorkingDay: "SetWorkingDay",
  SetWorkingTime: "SetWorkingTime",
  //Account
  AccountStack: "AccountStack",
  Account: "Account",
  BankDeposit: "BankDeposit",
  BankDepositAddNew: "BankDepositAddNew",
  AccountInviteExpert: "AccountInviteExpert",
  MyPatients: "MyPatients",
  AddPatientHub: "AddPatientHub",
  AddPatient: "AddPatient",
  PatientProfile: "PatientProfile",
  AddPrescription: "AddPrescription",
  AddCertificate: "AddCertificate",
  AddMedicalLicense: "AddMedicalLicense",
  AddFreePrescription: "AddFreePrescription",
  WebviewLoader: "WebviewLoader",
  SearchPatients: "SearchPatients",
  SearchClinicPatients: "SearchClinicPatients",
  SearchPractices: "SearchPractices",
  Services: "Services",
  DataUpdater: "DataUpdater",
  PatientMedicalInsurance: "PatientMedicalInsurance",
  PatientMedicalInsuranceHub: "PatientMedicalInsuranceHub",
  P: "p",
};

export default Routes;
